import posthog from 'posthog-js'

// Where a visitor came from, so launches (?ref=alternativeto, Reddit, Show HN)
// can be told apart. Only a short source label is kept: an allowlisted slug
// from ?ref= / ?utm_source=, else the referring site's hostname. Never a full
// URL — query strings can hold salary figures (the /should-i-quit share links).
// Held in memory only; it reaches analytics as a PostHog super property once
// the visitor has consented (see registerAttribution).

const SLUG = /^[a-z0-9][a-z0-9._-]{0,39}$/

let _source: string | null = null

export function referralSource(): string | null {
  return _source
}

/** Read the landing URL once, before the router rewrites it. */
export function captureAttribution(loc: Location = window.location, referrer = document.referrer) {
  const params = new URLSearchParams(loc.search)
  const tag = (params.get('ref') || params.get('utm_source') || '').trim().toLowerCase()
  if (SLUG.test(tag)) {
    _source = tag
    return
  }
  try {
    const host = referrer ? new URL(referrer).hostname.toLowerCase() : ''
    if (host && host !== loc.hostname.toLowerCase()) _source = host.replace(/^www\./, '')
  } catch { /* malformed referrer: no source */ }
}

/** First touch wins: register_once keeps the source a returning visitor first came with. */
export function registerAttribution() {
  if (_source) posthog.register_once({ referral_source: _source })
}
